import { Component, OnInit } from '@angular/core';
import { OpenIdProfileMixin } from 'src/app/mixin/open-id-profile.mixin';
import { OpenIdService } from 'src/app/service/open-id.service';

class NavBase {
    constructor(protected openIdService: OpenIdService) {}
}

const NavExtended = OpenIdProfileMixin(NavBase);

@Component({
    selector: 'app-component-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.css'],
})
export class NavComponent extends NavExtended implements OnInit {
    constructor(openIdService: OpenIdService) {
        super(openIdService);
    }

    ngOnInit(): void {}
}
